/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Api documentation
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ChatAgentRequestResp,
  CompactConversationResp,
  ContextUsageResp,
  ConversationArtifactListResp,
  ConversationDetailResp,
  ConversationFileListResp,
  ConversationListResp,
  FavoriteConversationBody,
  ListChatUserInputOptionsParams,
  ListConversationsParams,
  PinConversationBody,
  ResearchAnswerReq,
  ResearchRunResp,
  SaveUserInputReq,
  SetMessageFeedbackReq,
  SetMessageFeedbackResp,
  StartChatAgentRequestReq,
  StartUserInputTaskReq,
  SwitchVersionReq,
  SwitchVersionResp,
  UpdateConversationModelReq,
  UpdateConversationTitleReq,
  UserInputDialogueReq,
  UserInputDialogueResp,
  UserInputOptionsResp,
  UserInputRequestDO,
} from "./chat-api.schemas.js";

import { apiRequest } from "../context/api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const GetChatAgentRequest = (
  conversationId: string,
  messageId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ChatAgentRequestResp>(
    {
      url: `/intl/chat/conversations/${conversationId}/agent-requests/${messageId}`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetChatAgentRequestQueryKey = (
  conversationId: string,
  messageId: string,
) => {
  return [
    `/intl/chat/conversations/${conversationId}/agent-requests/${messageId}`,
  ] as const;
};

export const getGetChatAgentRequestQueryOptions = <
  TData = Awaited<ReturnType<typeof GetChatAgentRequest>>,
  TError = unknown,
>(
  conversationId: string,
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetChatAgentRequest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetChatAgentRequestQueryKey(conversationId, messageId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof GetChatAgentRequest>>
  > = ({ signal }) =>
    GetChatAgentRequest(conversationId, messageId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      conversationId !== null &&
      conversationId !== undefined &&
      messageId !== null &&
      messageId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof GetChatAgentRequest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetChatAgentRequestQueryResult = NonNullable<
  Awaited<ReturnType<typeof GetChatAgentRequest>>
>;
export type GetChatAgentRequestQueryError = unknown;

export function useGetChatAgentRequest<
  TData = Awaited<ReturnType<typeof GetChatAgentRequest>>,
  TError = unknown,
>(
  conversationId: string,
  messageId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetChatAgentRequest>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof GetChatAgentRequest>>,
          TError,
          Awaited<ReturnType<typeof GetChatAgentRequest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetChatAgentRequest<
  TData = Awaited<ReturnType<typeof GetChatAgentRequest>>,
  TError = unknown,
>(
  conversationId: string,
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetChatAgentRequest>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof GetChatAgentRequest>>,
          TError,
          Awaited<ReturnType<typeof GetChatAgentRequest>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetChatAgentRequest<
  TData = Awaited<ReturnType<typeof GetChatAgentRequest>>,
  TError = unknown,
>(
  conversationId: string,
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetChatAgentRequest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetChatAgentRequest<
  TData = Awaited<ReturnType<typeof GetChatAgentRequest>>,
  TError = unknown,
>(
  conversationId: string,
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetChatAgentRequest>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetChatAgentRequestQueryOptions(
    conversationId,
    messageId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const StartChatAgentRequest = (
  conversationId: string,
  messageId: string,
  startChatAgentRequestReq?: StartChatAgentRequestReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ChatAgentRequestResp>(
    {
      url: `/intl/chat/conversations/${conversationId}/agent-requests/${messageId}/start`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: startChatAgentRequestReq,
      signal,
    },
    options,
  );
};

export const getStartChatAgentRequestMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof StartChatAgentRequest>>,
    TError,
    {
      conversationId: string;
      messageId: string;
      data?: StartChatAgentRequestReq;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof StartChatAgentRequest>>,
  TError,
  {
    conversationId: string;
    messageId: string;
    data?: StartChatAgentRequestReq;
  },
  TContext
> => {
  const mutationKey = ["startChatAgentRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof StartChatAgentRequest>>,
    {
      conversationId: string;
      messageId: string;
      data?: StartChatAgentRequestReq;
    }
  > = (props) => {
    const { conversationId, messageId, data } = props ?? {};

    return StartChatAgentRequest(
      conversationId,
      messageId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type StartChatAgentRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof StartChatAgentRequest>>
>;
export type StartChatAgentRequestMutationBody =
  StartChatAgentRequestReq | undefined;
export type StartChatAgentRequestMutationError = unknown;

export const useStartChatAgentRequest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof StartChatAgentRequest>>,
      TError,
      {
        conversationId: string;
        messageId: string;
        data?: StartChatAgentRequestReq;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof StartChatAgentRequest>>,
  TError,
  {
    conversationId: string;
    messageId: string;
    data?: StartChatAgentRequestReq;
  },
  TContext
> => {
  return useMutation(
    getStartChatAgentRequestMutationOptions(options),
    queryClient,
  );
};
export const CancelChatAgentRequest = (
  conversationId: string,
  messageId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ChatAgentRequestResp>(
    {
      url: `/intl/chat/conversations/${conversationId}/agent-requests/${messageId}/cancel`,
      method: "POST",
      signal,
    },
    options,
  );
};

export const getCancelChatAgentRequestMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof CancelChatAgentRequest>>,
    TError,
    { conversationId: string; messageId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof CancelChatAgentRequest>>,
  TError,
  { conversationId: string; messageId: string },
  TContext
> => {
  const mutationKey = ["cancelChatAgentRequest"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof CancelChatAgentRequest>>,
    { conversationId: string; messageId: string }
  > = (props) => {
    const { conversationId, messageId } = props ?? {};

    return CancelChatAgentRequest(conversationId, messageId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelChatAgentRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof CancelChatAgentRequest>>
>;

export type CancelChatAgentRequestMutationError = unknown;

export const useCancelChatAgentRequest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof CancelChatAgentRequest>>,
      TError,
      { conversationId: string; messageId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof CancelChatAgentRequest>>,
  TError,
  { conversationId: string; messageId: string },
  TContext
> => {
  return useMutation(
    getCancelChatAgentRequestMutationOptions(options),
    queryClient,
  );
};
export const GetChatUserInput = (
  id: string,
  messageId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<UserInputRequestDO>(
    {
      url: `/intl/chat/conversations/${id}/messages/${messageId}/input`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetChatUserInputQueryKey = (id: string, messageId: string) => {
  return [
    `/intl/chat/conversations/${id}/messages/${messageId}/input`,
  ] as const;
};

export const getGetChatUserInputQueryOptions = <
  TData = Awaited<ReturnType<typeof GetChatUserInput>>,
  TError = unknown,
>(
  id: string,
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetChatUserInput>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetChatUserInputQueryKey(id, messageId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof GetChatUserInput>>
  > = ({ signal }) => GetChatUserInput(id, messageId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      id !== null &&
      id !== undefined &&
      messageId !== null &&
      messageId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof GetChatUserInput>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetChatUserInputQueryResult = NonNullable<
  Awaited<ReturnType<typeof GetChatUserInput>>
>;
export type GetChatUserInputQueryError = unknown;

export function useGetChatUserInput<
  TData = Awaited<ReturnType<typeof GetChatUserInput>>,
  TError = unknown,
>(
  id: string,
  messageId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetChatUserInput>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof GetChatUserInput>>,
          TError,
          Awaited<ReturnType<typeof GetChatUserInput>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetChatUserInput<
  TData = Awaited<ReturnType<typeof GetChatUserInput>>,
  TError = unknown,
>(
  id: string,
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetChatUserInput>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof GetChatUserInput>>,
          TError,
          Awaited<ReturnType<typeof GetChatUserInput>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetChatUserInput<
  TData = Awaited<ReturnType<typeof GetChatUserInput>>,
  TError = unknown,
>(
  id: string,
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetChatUserInput>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetChatUserInput<
  TData = Awaited<ReturnType<typeof GetChatUserInput>>,
  TError = unknown,
>(
  id: string,
  messageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetChatUserInput>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetChatUserInputQueryOptions(id, messageId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const SaveChatUserInput = (
  id: string,
  messageId: string,
  saveUserInputReq?: SaveUserInputReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<UserInputRequestDO>(
    {
      url: `/intl/chat/conversations/${id}/messages/${messageId}/input`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: saveUserInputReq,
      signal,
    },
    options,
  );
};

export const getSaveChatUserInputMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof SaveChatUserInput>>,
    TError,
    { id: string; messageId: string; data?: SaveUserInputReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof SaveChatUserInput>>,
  TError,
  { id: string; messageId: string; data?: SaveUserInputReq },
  TContext
> => {
  const mutationKey = ["saveChatUserInput"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof SaveChatUserInput>>,
    { id: string; messageId: string; data?: SaveUserInputReq }
  > = (props) => {
    const { id, messageId, data } = props ?? {};

    return SaveChatUserInput(id, messageId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveChatUserInputMutationResult = NonNullable<
  Awaited<ReturnType<typeof SaveChatUserInput>>
>;
export type SaveChatUserInputMutationBody = SaveUserInputReq | undefined;
export type SaveChatUserInputMutationError = unknown;

export const useSaveChatUserInput = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof SaveChatUserInput>>,
      TError,
      { id: string; messageId: string; data?: SaveUserInputReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof SaveChatUserInput>>,
  TError,
  { id: string; messageId: string; data?: SaveUserInputReq },
  TContext
> => {
  return useMutation(getSaveChatUserInputMutationOptions(options), queryClient);
};
export const ChatUserInputDialogue = (
  id: string,
  messageId: string,
  userInputDialogueReq?: UserInputDialogueReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<UserInputDialogueResp>(
    {
      url: `/intl/chat/conversations/${id}/messages/${messageId}/input/dialogue`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: userInputDialogueReq,
      signal,
    },
    options,
  );
};

export const getChatUserInputDialogueMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof ChatUserInputDialogue>>,
    TError,
    { id: string; messageId: string; data?: UserInputDialogueReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof ChatUserInputDialogue>>,
  TError,
  { id: string; messageId: string; data?: UserInputDialogueReq },
  TContext
> => {
  const mutationKey = ["chatUserInputDialogue"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof ChatUserInputDialogue>>,
    { id: string; messageId: string; data?: UserInputDialogueReq }
  > = (props) => {
    const { id, messageId, data } = props ?? {};

    return ChatUserInputDialogue(id, messageId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ChatUserInputDialogueMutationResult = NonNullable<
  Awaited<ReturnType<typeof ChatUserInputDialogue>>
>;
export type ChatUserInputDialogueMutationBody =
  UserInputDialogueReq | undefined;
export type ChatUserInputDialogueMutationError = unknown;

export const useChatUserInputDialogue = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof ChatUserInputDialogue>>,
      TError,
      { id: string; messageId: string; data?: UserInputDialogueReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof ChatUserInputDialogue>>,
  TError,
  { id: string; messageId: string; data?: UserInputDialogueReq },
  TContext
> => {
  return useMutation(
    getChatUserInputDialogueMutationOptions(options),
    queryClient,
  );
};
export const StartUserInputTask = (
  id: string,
  messageId: string,
  startUserInputTaskReq?: StartUserInputTaskReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ChatAgentRequestResp>(
    {
      url: `/intl/chat/conversations/${id}/messages/${messageId}/input/start-task`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: startUserInputTaskReq,
      signal,
    },
    options,
  );
};

export const getStartUserInputTaskMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof StartUserInputTask>>,
    TError,
    { id: string; messageId: string; data?: StartUserInputTaskReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof StartUserInputTask>>,
  TError,
  { id: string; messageId: string; data?: StartUserInputTaskReq },
  TContext
> => {
  const mutationKey = ["startUserInputTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof StartUserInputTask>>,
    { id: string; messageId: string; data?: StartUserInputTaskReq }
  > = (props) => {
    const { id, messageId, data } = props ?? {};

    return StartUserInputTask(id, messageId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartUserInputTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof StartUserInputTask>>
>;
export type StartUserInputTaskMutationBody = StartUserInputTaskReq | undefined;
export type StartUserInputTaskMutationError = unknown;

export const useStartUserInputTask = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof StartUserInputTask>>,
      TError,
      { id: string; messageId: string; data?: StartUserInputTaskReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof StartUserInputTask>>,
  TError,
  { id: string; messageId: string; data?: StartUserInputTaskReq },
  TContext
> => {
  return useMutation(
    getStartUserInputTaskMutationOptions(options),
    queryClient,
  );
};
export const ListChatUserInputOptions = (
  id: string,
  messageId: string,
  params?: ListChatUserInputOptionsParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<UserInputOptionsResp>(
    {
      url: `/intl/chat/conversations/${id}/messages/${messageId}/input/options`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getListChatUserInputOptionsQueryKey = (
  id: string,
  messageId: string,
  params?: ListChatUserInputOptionsParams,
) => {
  return [
    `/intl/chat/conversations/${id}/messages/${messageId}/input/options`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListChatUserInputOptionsQueryOptions = <
  TData = Awaited<ReturnType<typeof ListChatUserInputOptions>>,
  TError = unknown,
>(
  id: string,
  messageId: string,
  params?: ListChatUserInputOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListChatUserInputOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListChatUserInputOptionsQueryKey(id, messageId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof ListChatUserInputOptions>>
  > = ({ signal }) =>
    ListChatUserInputOptions(id, messageId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled:
      id !== null &&
      id !== undefined &&
      messageId !== null &&
      messageId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof ListChatUserInputOptions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListChatUserInputOptionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof ListChatUserInputOptions>>
>;
export type ListChatUserInputOptionsQueryError = unknown;

export function useListChatUserInputOptions<
  TData = Awaited<ReturnType<typeof ListChatUserInputOptions>>,
  TError = unknown,
>(
  id: string,
  messageId: string,
  params: undefined | ListChatUserInputOptionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListChatUserInputOptions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ListChatUserInputOptions>>,
          TError,
          Awaited<ReturnType<typeof ListChatUserInputOptions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListChatUserInputOptions<
  TData = Awaited<ReturnType<typeof ListChatUserInputOptions>>,
  TError = unknown,
>(
  id: string,
  messageId: string,
  params?: ListChatUserInputOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListChatUserInputOptions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ListChatUserInputOptions>>,
          TError,
          Awaited<ReturnType<typeof ListChatUserInputOptions>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListChatUserInputOptions<
  TData = Awaited<ReturnType<typeof ListChatUserInputOptions>>,
  TError = unknown,
>(
  id: string,
  messageId: string,
  params?: ListChatUserInputOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListChatUserInputOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListChatUserInputOptions<
  TData = Awaited<ReturnType<typeof ListChatUserInputOptions>>,
  TError = unknown,
>(
  id: string,
  messageId: string,
  params?: ListChatUserInputOptionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListChatUserInputOptions>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListChatUserInputOptionsQueryOptions(
    id,
    messageId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const GetChatResearch = (
  runId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ResearchRunResp>(
    { url: `/intl/chat/research/${runId}`, method: "GET", signal },
    options,
  );
};

export const getGetChatResearchQueryKey = (runId: string) => {
  return [`/intl/chat/research/${runId}`] as const;
};

export const getGetChatResearchQueryOptions = <
  TData = Awaited<ReturnType<typeof GetChatResearch>>,
  TError = unknown,
>(
  runId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetChatResearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetChatResearchQueryKey(runId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof GetChatResearch>>> = ({
    signal,
  }) => GetChatResearch(runId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: runId !== null && runId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof GetChatResearch>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetChatResearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof GetChatResearch>>
>;
export type GetChatResearchQueryError = unknown;

export function useGetChatResearch<
  TData = Awaited<ReturnType<typeof GetChatResearch>>,
  TError = unknown,
>(
  runId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetChatResearch>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof GetChatResearch>>,
          TError,
          Awaited<ReturnType<typeof GetChatResearch>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetChatResearch<
  TData = Awaited<ReturnType<typeof GetChatResearch>>,
  TError = unknown,
>(
  runId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetChatResearch>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof GetChatResearch>>,
          TError,
          Awaited<ReturnType<typeof GetChatResearch>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetChatResearch<
  TData = Awaited<ReturnType<typeof GetChatResearch>>,
  TError = unknown,
>(
  runId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetChatResearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetChatResearch<
  TData = Awaited<ReturnType<typeof GetChatResearch>>,
  TError = unknown,
>(
  runId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetChatResearch>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetChatResearchQueryOptions(runId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const CancelChatResearch = (
  runId: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ResearchRunResp>(
    { url: `/intl/chat/research/${runId}/cancel`, method: "POST", signal },
    options,
  );
};

export const getCancelChatResearchMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof CancelChatResearch>>,
    TError,
    { runId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof CancelChatResearch>>,
  TError,
  { runId: string },
  TContext
> => {
  const mutationKey = ["cancelChatResearch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof CancelChatResearch>>,
    { runId: string }
  > = (props) => {
    const { runId } = props ?? {};

    return CancelChatResearch(runId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelChatResearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof CancelChatResearch>>
>;

export type CancelChatResearchMutationError = unknown;

export const useCancelChatResearch = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof CancelChatResearch>>,
      TError,
      { runId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof CancelChatResearch>>,
  TError,
  { runId: string },
  TContext
> => {
  return useMutation(
    getCancelChatResearchMutationOptions(options),
    queryClient,
  );
};
export const AnswerChatResearch = (
  runId: string,
  researchAnswerReq?: ResearchAnswerReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ResearchRunResp>(
    {
      url: `/intl/chat/research/${runId}/answer`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: researchAnswerReq,
      signal,
    },
    options,
  );
};

export const getAnswerChatResearchMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof AnswerChatResearch>>,
    TError,
    { runId: string; data?: ResearchAnswerReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof AnswerChatResearch>>,
  TError,
  { runId: string; data?: ResearchAnswerReq },
  TContext
> => {
  const mutationKey = ["answerChatResearch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof AnswerChatResearch>>,
    { runId: string; data?: ResearchAnswerReq }
  > = (props) => {
    const { runId, data } = props ?? {};

    return AnswerChatResearch(runId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AnswerChatResearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof AnswerChatResearch>>
>;
export type AnswerChatResearchMutationBody = ResearchAnswerReq | undefined;
export type AnswerChatResearchMutationError = unknown;

export const useAnswerChatResearch = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof AnswerChatResearch>>,
      TError,
      { runId: string; data?: ResearchAnswerReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof AnswerChatResearch>>,
  TError,
  { runId: string; data?: ResearchAnswerReq },
  TContext
> => {
  return useMutation(
    getAnswerChatResearchMutationOptions(options),
    queryClient,
  );
};
export const ListConversations = (
  params?: ListConversationsParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ConversationListResp>(
    { url: `/intl/chat/conversations`, method: "GET", params, signal },
    options,
  );
};

export const getListConversationsQueryKey = (
  params?: ListConversationsParams,
) => {
  return [`/intl/chat/conversations`, ...(params ? [params] : [])] as const;
};

export const getListConversationsQueryOptions = <
  TData = Awaited<ReturnType<typeof ListConversations>>,
  TError = unknown,
>(
  params?: ListConversationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListConversations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListConversationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof ListConversations>>
  > = ({ signal }) => ListConversations(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof ListConversations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListConversationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof ListConversations>>
>;
export type ListConversationsQueryError = unknown;

export function useListConversations<
  TData = Awaited<ReturnType<typeof ListConversations>>,
  TError = unknown,
>(
  params: undefined | ListConversationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListConversations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ListConversations>>,
          TError,
          Awaited<ReturnType<typeof ListConversations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListConversations<
  TData = Awaited<ReturnType<typeof ListConversations>>,
  TError = unknown,
>(
  params?: ListConversationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListConversations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ListConversations>>,
          TError,
          Awaited<ReturnType<typeof ListConversations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListConversations<
  TData = Awaited<ReturnType<typeof ListConversations>>,
  TError = unknown,
>(
  params?: ListConversationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListConversations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListConversations<
  TData = Awaited<ReturnType<typeof ListConversations>>,
  TError = unknown,
>(
  params?: ListConversationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListConversations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListConversationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const GetConversation = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ConversationDetailResp>(
    { url: `/intl/chat/conversations/${id}`, method: "GET", signal },
    options,
  );
};

export const getGetConversationQueryKey = (id: string) => {
  return [`/intl/chat/conversations/${id}`] as const;
};

export const getGetConversationQueryOptions = <
  TData = Awaited<ReturnType<typeof GetConversation>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetConversation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetConversationQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof GetConversation>>> = ({
    signal,
  }) => GetConversation(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof GetConversation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConversationQueryResult = NonNullable<
  Awaited<ReturnType<typeof GetConversation>>
>;
export type GetConversationQueryError = unknown;

export function useGetConversation<
  TData = Awaited<ReturnType<typeof GetConversation>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetConversation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof GetConversation>>,
          TError,
          Awaited<ReturnType<typeof GetConversation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversation<
  TData = Awaited<ReturnType<typeof GetConversation>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetConversation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof GetConversation>>,
          TError,
          Awaited<ReturnType<typeof GetConversation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversation<
  TData = Awaited<ReturnType<typeof GetConversation>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetConversation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetConversation<
  TData = Awaited<ReturnType<typeof GetConversation>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetConversation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetConversationQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const UpdateConversationTitle = (
  id: string,
  updateConversationTitleReq?: UpdateConversationTitleReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/intl/chat/conversations/${id}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateConversationTitleReq,
      signal,
    },
    options,
  );
};

export const getUpdateConversationTitleMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof UpdateConversationTitle>>,
    TError,
    { id: string; data?: UpdateConversationTitleReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof UpdateConversationTitle>>,
  TError,
  { id: string; data?: UpdateConversationTitleReq },
  TContext
> => {
  const mutationKey = ["updateConversationTitle"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof UpdateConversationTitle>>,
    { id: string; data?: UpdateConversationTitleReq }
  > = (props) => {
    const { id, data } = props ?? {};

    return UpdateConversationTitle(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateConversationTitleMutationResult = NonNullable<
  Awaited<ReturnType<typeof UpdateConversationTitle>>
>;
export type UpdateConversationTitleMutationBody =
  UpdateConversationTitleReq | undefined;
export type UpdateConversationTitleMutationError = unknown;

export const useUpdateConversationTitle = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof UpdateConversationTitle>>,
      TError,
      { id: string; data?: UpdateConversationTitleReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof UpdateConversationTitle>>,
  TError,
  { id: string; data?: UpdateConversationTitleReq },
  TContext
> => {
  return useMutation(
    getUpdateConversationTitleMutationOptions(options),
    queryClient,
  );
};
export const DeleteConversation = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    { url: `/intl/chat/conversations/${id}`, method: "DELETE", signal },
    options,
  );
};

export const getDeleteConversationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof DeleteConversation>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof DeleteConversation>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteConversation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof DeleteConversation>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return DeleteConversation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof DeleteConversation>>
>;

export type DeleteConversationMutationError = unknown;

export const useDeleteConversation = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof DeleteConversation>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof DeleteConversation>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(
    getDeleteConversationMutationOptions(options),
    queryClient,
  );
};
export const PinConversation = (
  id: string,
  pinConversationBody?: PinConversationBody,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/intl/chat/conversations/${id}/pin`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: pinConversationBody,
      signal,
    },
    options,
  );
};

export const getPinConversationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof PinConversation>>,
    TError,
    { id: string; data?: PinConversationBody },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof PinConversation>>,
  TError,
  { id: string; data?: PinConversationBody },
  TContext
> => {
  const mutationKey = ["pinConversation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof PinConversation>>,
    { id: string; data?: PinConversationBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return PinConversation(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PinConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof PinConversation>>
>;
export type PinConversationMutationBody = PinConversationBody | undefined;
export type PinConversationMutationError = unknown;

export const usePinConversation = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof PinConversation>>,
      TError,
      { id: string; data?: PinConversationBody },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof PinConversation>>,
  TError,
  { id: string; data?: PinConversationBody },
  TContext
> => {
  return useMutation(getPinConversationMutationOptions(options), queryClient);
};
export const FavoriteConversation = (
  id: string,
  favoriteConversationBody?: FavoriteConversationBody,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/intl/chat/conversations/${id}/favorite`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: favoriteConversationBody,
      signal,
    },
    options,
  );
};

export const getFavoriteConversationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof FavoriteConversation>>,
    TError,
    { id: string; data?: FavoriteConversationBody },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof FavoriteConversation>>,
  TError,
  { id: string; data?: FavoriteConversationBody },
  TContext
> => {
  const mutationKey = ["favoriteConversation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof FavoriteConversation>>,
    { id: string; data?: FavoriteConversationBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return FavoriteConversation(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FavoriteConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof FavoriteConversation>>
>;
export type FavoriteConversationMutationBody =
  FavoriteConversationBody | undefined;
export type FavoriteConversationMutationError = unknown;

export const useFavoriteConversation = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof FavoriteConversation>>,
      TError,
      { id: string; data?: FavoriteConversationBody },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof FavoriteConversation>>,
  TError,
  { id: string; data?: FavoriteConversationBody },
  TContext
> => {
  return useMutation(
    getFavoriteConversationMutationOptions(options),
    queryClient,
  );
};
export const UpdateConversationModel = (
  id: string,
  updateConversationModelReq?: UpdateConversationModelReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<void>(
    {
      url: `/intl/chat/conversations/${id}/model`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateConversationModelReq,
      signal,
    },
    options,
  );
};

export const getUpdateConversationModelMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof UpdateConversationModel>>,
    TError,
    { id: string; data?: UpdateConversationModelReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof UpdateConversationModel>>,
  TError,
  { id: string; data?: UpdateConversationModelReq },
  TContext
> => {
  const mutationKey = ["updateConversationModel"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof UpdateConversationModel>>,
    { id: string; data?: UpdateConversationModelReq }
  > = (props) => {
    const { id, data } = props ?? {};

    return UpdateConversationModel(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateConversationModelMutationResult = NonNullable<
  Awaited<ReturnType<typeof UpdateConversationModel>>
>;
export type UpdateConversationModelMutationBody =
  UpdateConversationModelReq | undefined;
export type UpdateConversationModelMutationError = unknown;

export const useUpdateConversationModel = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof UpdateConversationModel>>,
      TError,
      { id: string; data?: UpdateConversationModelReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof UpdateConversationModel>>,
  TError,
  { id: string; data?: UpdateConversationModelReq },
  TContext
> => {
  return useMutation(
    getUpdateConversationModelMutationOptions(options),
    queryClient,
  );
};
export const GetContextUsage = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ContextUsageResp>(
    {
      url: `/intl/chat/conversations/${id}/context-usage`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetContextUsageQueryKey = (id: string) => {
  return [`/intl/chat/conversations/${id}/context-usage`] as const;
};

export const getGetContextUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof GetContextUsage>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetContextUsage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetContextUsageQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof GetContextUsage>>> = ({
    signal,
  }) => GetContextUsage(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof GetContextUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetContextUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof GetContextUsage>>
>;
export type GetContextUsageQueryError = unknown;

export function useGetContextUsage<
  TData = Awaited<ReturnType<typeof GetContextUsage>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetContextUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof GetContextUsage>>,
          TError,
          Awaited<ReturnType<typeof GetContextUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContextUsage<
  TData = Awaited<ReturnType<typeof GetContextUsage>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetContextUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof GetContextUsage>>,
          TError,
          Awaited<ReturnType<typeof GetContextUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetContextUsage<
  TData = Awaited<ReturnType<typeof GetContextUsage>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetContextUsage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetContextUsage<
  TData = Awaited<ReturnType<typeof GetContextUsage>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof GetContextUsage>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetContextUsageQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const ListConversationArtifacts = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ConversationArtifactListResp>(
    { url: `/intl/chat/conversations/${id}/artifacts`, method: "GET", signal },
    options,
  );
};

export const getListConversationArtifactsQueryKey = (id: string) => {
  return [`/intl/chat/conversations/${id}/artifacts`] as const;
};

export const getListConversationArtifactsQueryOptions = <
  TData = Awaited<ReturnType<typeof ListConversationArtifacts>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListConversationArtifacts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListConversationArtifactsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof ListConversationArtifacts>>
  > = ({ signal }) => ListConversationArtifacts(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof ListConversationArtifacts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListConversationArtifactsQueryResult = NonNullable<
  Awaited<ReturnType<typeof ListConversationArtifacts>>
>;
export type ListConversationArtifactsQueryError = unknown;

export function useListConversationArtifacts<
  TData = Awaited<ReturnType<typeof ListConversationArtifacts>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListConversationArtifacts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ListConversationArtifacts>>,
          TError,
          Awaited<ReturnType<typeof ListConversationArtifacts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListConversationArtifacts<
  TData = Awaited<ReturnType<typeof ListConversationArtifacts>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListConversationArtifacts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ListConversationArtifacts>>,
          TError,
          Awaited<ReturnType<typeof ListConversationArtifacts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListConversationArtifacts<
  TData = Awaited<ReturnType<typeof ListConversationArtifacts>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListConversationArtifacts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListConversationArtifacts<
  TData = Awaited<ReturnType<typeof ListConversationArtifacts>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListConversationArtifacts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListConversationArtifactsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const ListConversationFiles = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<ConversationFileListResp>(
    { url: `/intl/chat/conversations/${id}/files`, method: "GET", signal },
    options,
  );
};

export const getListConversationFilesQueryKey = (id: string) => {
  return [`/intl/chat/conversations/${id}/files`] as const;
};

export const getListConversationFilesQueryOptions = <
  TData = Awaited<ReturnType<typeof ListConversationFiles>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListConversationFiles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListConversationFilesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof ListConversationFiles>>
  > = ({ signal }) => ListConversationFiles(id, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof ListConversationFiles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListConversationFilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof ListConversationFiles>>
>;
export type ListConversationFilesQueryError = unknown;

export function useListConversationFiles<
  TData = Awaited<ReturnType<typeof ListConversationFiles>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListConversationFiles>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ListConversationFiles>>,
          TError,
          Awaited<ReturnType<typeof ListConversationFiles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListConversationFiles<
  TData = Awaited<ReturnType<typeof ListConversationFiles>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListConversationFiles>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ListConversationFiles>>,
          TError,
          Awaited<ReturnType<typeof ListConversationFiles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListConversationFiles<
  TData = Awaited<ReturnType<typeof ListConversationFiles>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListConversationFiles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useListConversationFiles<
  TData = Awaited<ReturnType<typeof ListConversationFiles>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof ListConversationFiles>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListConversationFilesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const CompactConversation = (
  id: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<CompactConversationResp>(
    { url: `/intl/chat/conversations/${id}/compact`, method: "POST", signal },
    options,
  );
};

export const getCompactConversationMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof CompactConversation>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof CompactConversation>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["compactConversation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof CompactConversation>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return CompactConversation(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompactConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof CompactConversation>>
>;

export type CompactConversationMutationError = unknown;

export const useCompactConversation = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof CompactConversation>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof CompactConversation>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(
    getCompactConversationMutationOptions(options),
    queryClient,
  );
};
export const SwitchVersion = (
  id: string,
  messageId: string,
  switchVersionReq?: SwitchVersionReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<SwitchVersionResp>(
    {
      url: `/intl/chat/conversations/${id}/messages/${messageId}/switch-version`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: switchVersionReq,
      signal,
    },
    options,
  );
};

export const getSwitchVersionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof SwitchVersion>>,
    TError,
    { id: string; messageId: string; data?: SwitchVersionReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof SwitchVersion>>,
  TError,
  { id: string; messageId: string; data?: SwitchVersionReq },
  TContext
> => {
  const mutationKey = ["switchVersion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof SwitchVersion>>,
    { id: string; messageId: string; data?: SwitchVersionReq }
  > = (props) => {
    const { id, messageId, data } = props ?? {};

    return SwitchVersion(id, messageId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SwitchVersionMutationResult = NonNullable<
  Awaited<ReturnType<typeof SwitchVersion>>
>;
export type SwitchVersionMutationBody = SwitchVersionReq | undefined;
export type SwitchVersionMutationError = unknown;

export const useSwitchVersion = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof SwitchVersion>>,
      TError,
      { id: string; messageId: string; data?: SwitchVersionReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof SwitchVersion>>,
  TError,
  { id: string; messageId: string; data?: SwitchVersionReq },
  TContext
> => {
  return useMutation(getSwitchVersionMutationOptions(options), queryClient);
};
export const SetMessageFeedback = (
  id: string,
  messageId: string,
  setMessageFeedbackReq?: SetMessageFeedbackReq,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<SetMessageFeedbackResp>(
    {
      url: `/intl/chat/conversations/${id}/messages/${messageId}/feedback`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: setMessageFeedbackReq,
      signal,
    },
    options,
  );
};

export const getSetMessageFeedbackMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof SetMessageFeedback>>,
    TError,
    { id: string; messageId: string; data?: SetMessageFeedbackReq },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof SetMessageFeedback>>,
  TError,
  { id: string; messageId: string; data?: SetMessageFeedbackReq },
  TContext
> => {
  const mutationKey = ["setMessageFeedback"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof SetMessageFeedback>>,
    { id: string; messageId: string; data?: SetMessageFeedbackReq }
  > = (props) => {
    const { id, messageId, data } = props ?? {};

    return SetMessageFeedback(id, messageId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetMessageFeedbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof SetMessageFeedback>>
>;
export type SetMessageFeedbackMutationBody = SetMessageFeedbackReq | undefined;
export type SetMessageFeedbackMutationError = unknown;

export const useSetMessageFeedback = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof SetMessageFeedback>>,
      TError,
      { id: string; messageId: string; data?: SetMessageFeedbackReq },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof SetMessageFeedback>>,
  TError,
  { id: string; messageId: string; data?: SetMessageFeedbackReq },
  TContext
> => {
  return useMutation(
    getSetMessageFeedbackMutationOptions(options),
    queryClient,
  );
};
